import { z } from 'zod';
import { defineEndpoint } from '../define';
import { RunnerMachineOsSchema } from '../runner-agent/shapes';
import { MachineSchema } from './shapes';

export const CreateMachineBodySchema = z.object({
  name: z
    .string()
    .trim()
    .min(1)
    .max(64)
    .regex(/^[A-Za-z0-9_.-]+$/, 'Letters, digits, dot, dash and underscore only'),
  os: RunnerMachineOsSchema,
});
export type CreateMachineBody = z.infer<typeof CreateMachineBodySchema>;

/** The agent token is returned exactly once; only its hash is stored. */
export const createRunnerMachine = defineEndpoint({
  method: 'POST',
  path: '/v1/runner-monitor/machines',
  params: z.object({}),
  query: z.object({}),
  body: CreateMachineBodySchema,
  response: z.object({ data: z.object({ machine: MachineSchema, token: z.string() }) }),
  successStatus: 201,
});
